import * as Sentry from '@sentry/react'
import { FEATURE_FLAGS } from 'shared/constants/featureFlags'

export function initializeSentry(): void {
  const dsn = process.env.REACT_APP_SENTRY_DSN
  if (!FEATURE_FLAGS.SENTRY_ENABLED || !dsn) return

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
      stackFrameVariables: false
    }
  })
}

initializeSentry()
